import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  valueWithIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  statusIcon: {
    fontSize: '1.2rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inactiveIcon: {
    color: theme.palette.grey[500],
  },
  criticalityLowIcon: {
    color: theme.palette.info.main,
  },
  criticalityMediumIcon: {
    color: theme.palette.warning.main,
  },
  criticalityHighIcon: {
    color: theme.palette.error.main,
  },
  stickyMenuContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    minWidth: 200,
    marginLeft: theme.spacing(1),
  },
  progressBarWrapper: {
    flex: 1,
    minWidth: 120,
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    '& .MuiLinearProgress-bar': {
      borderRadius: 4,
      transition: 'transform 0.4s ease-in-out',
    },
  },
  progressColorHigh: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.success.main,
    },
  },
  progressColorMedium: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  progressColorLow: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.warning.light,
    },
  },
  progressColorVeryLow: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.error.light,
    },
  },
  progressPercentage: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
  },
  deadlineContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  deadlineText: {
    color: 'inherit',
    fontWeight: 'normal',
  },
  deadlineTextPast: {
    color: '#f44336',
    fontWeight: 'bold',
  },
  reminderContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  reminderIcon: {
    fontSize: '1rem',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  reminderIconPast: {
    fontSize: '1rem',
    color: '#ff9800',
  },
  reminderText: {
    color: 'inherit',
  },
  reminderTextPast: {
    color: '#ff9800',
  },
  descriptionText: {
    marginBottom: theme.spacing(1),
  },
}));
